import { get, isString } from "lodash";
import React from "react";
import { EditorAuth } from "./EditorAuth";

let localeData: Record<string, string> = {};
let isEnabled = false;
let hasChecked = false;
class I18nManagerCore {
  async checkLocaleData() {
    let interval = setInterval(() => {
      const authState = EditorAuth.getAuthState();
      if (authState === "SUCCESS") {
        isEnabled = EditorAuth.getFeatureEnabled("LOCALIZATION");
        hasChecked = true;
        clearInterval(interval);
      }
    }, 100);
  }

  setLocaleData(data: Record<string, string>) {
    localeData = data;
    if (!hasChecked) {
      this.checkLocaleData();
    }
  }

  translate(key: string, placeholder?: React.ReactNode): string;
  translate(key: string, placeholder: React.ReactNode) {
    return this.translateWithParams(key, placeholder);
  }

  private translateWithParams(key: string, placeholder: React.ReactNode): any {
    if (hasChecked && !isEnabled) {
      throw new Error(`Current plan do not support localization`);
    }
    const translationValue = get(localeData, key, key);
    if (!placeholder) {
      return translationValue;
    }
    const arr: React.ReactNode[] = translationValue.split("***");
    arr.splice(1, 0, placeholder);

    if (isString(placeholder)) {
      return arr.join("");
    }
    return (
      <>
        {arr.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </>
    );
  }
}

export const I18nManager = Object.freeze(new I18nManagerCore());

export const t = I18nManager.translate.bind(I18nManager);
